$(function () {
    var $stat_counter_element = $('.control-stat-counter');
    var $stat_elements = $('.control-stat-counter .stat-value');
    var $window = $(window);
    var counting = false;

    if ($stat_counter_element.length) { 
        function inc_counter() {
            var window_height = $window.height();
            var window_top_position = $window.scrollTop();
            var window_bottom_position = (window_top_position + window_height);

            var element_height = $stat_counter_element.outerHeight();
            var element_top_position = $stat_counter_element.offset().top;
            var element_bottom_position = (element_top_position + element_height);

            if (((element_top_position + (window_height / 6) <= window_bottom_position) || element_bottom_position <= window_bottom_position + 20) && !$stat_counter_element.hasClass('counted') && !counting) {
                counting = true;

                $.each($stat_elements, function () {
                    var $element = $(this),
                        countTo = $element.text();

                    $({ countNum: 1 }).animate(
                        {
                            countNum: countTo
                        },
                        {
                            duration: 5000,
                            easing: "linear",
                            step: function () {
                                $element.text(Math.floor(this.countNum));
                            },
                            complete: function () {
                                $stat_counter_element.addClass('counted');
                                $element.text(this.countNum);
                            }
                        }
                    );
                });
            }
        }

        $(function () {
            $window.on('scroll', inc_counter);

            setTimeout(function () {
                $window.trigger('scroll');
            }, 200);
        });
    }
}); 
